import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { TabbedPageLayoutComponent } from 'app/layout/page-layouts/tabbed/tabbed-page-layout.component';
import { PermissionGuard } from 'app/core/permissions/permissions.guard';

export const emailRoutes: Route[] = [
    {
        path: 'email',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'templates',
                pathMatch: 'full',
            },
            {
                path: 'templates',
                data: {
                    breadcrumbs: [{ label: 'email.templates.title' }],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                        {
                            label: 'actions.new',
                            route: '/email/templates/new',
                            color: 'primary',
                        },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        data: {
                            tabs: [],
                        },
                        loadComponent: () =>
                            import(
                                './components/template-list/template-list.component'
                            ).then((c) => c.TemplateListComponent),
                    },
                    {
                        path: 'new',
                        data: {
                            breadcrumbs: [
                                {
                                    label: 'email.templates.title',
                                    link: '/email/templates',
                                },
                                { label: 'email.templates.new' },
                            ],
                        },
                        loadComponent: () =>
                            import(
                                './components/template-form/template-form.component'
                            ).then((c) => c.TemplateFormComponent),
                    },
                    {
                        path: ':id',
                        data: {
                            breadcrumbs: [
                                {
                                    label: 'email.templates.title',
                                    link: '/email/templates',
                                },
                                { label: 'email.templates.edit' },
                            ],
                            tabs: [{ label: 'common.details', route: 'edit' }],
                        },
                        children: [
                            {
                                path: '',
                                redirectTo: 'edit',
                                pathMatch: 'full',
                            },
                            {
                                path: 'edit',
                                loadComponent: () =>
                                    import(
                                        './components/template-form/template-form.component'
                                    ).then((c) => c.TemplateFormComponent),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'logs',
                data: {
                    breadcrumbs: [{ label: 'email.logs.title' }],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        data: {
                            tabs: [],
                        },
                        loadComponent: () =>
                            import(
                                './components/log-list/log-list.component'
                            ).then((c) => c.LogListComponent),
                    },
                    {
                        path: ':id',
                        data: {
                            breadcrumbs: [
                                {
                                    label: 'email.logs.title',
                                    link: '/email/logs',
                                },
                                { label: 'email.logs.details' },
                            ],
                            tabs: [{ label: 'common.details', route: 'view' }],
                        },
                        children: [
                            {
                                path: '',
                                redirectTo: 'view',
                                pathMatch: 'full',
                            },
                            {
                                path: 'view',
                                loadComponent: () =>
                                    import(
                                        './components/log-detail/log-detail.component'
                                    ).then((c) => c.LogDetailComponent),
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
